<script>
import HealthSurveyQuestions from '@components/mental-health-survey/health-survey-questions.vue'
export default {
  page: {
    title: 'Mental Health Survey',
    meta: [{ name: 'description', content: 'The Mental Health Survey page.' }],
  },
  components: {
    HealthSurveyQuestions,
  },
}
</script>

<template>
  <v-container>
    <HealthSurveyQuestions></HealthSurveyQuestions>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
</style>
